<template>
    <v-row>
        <v-col cols="12" class="text-center">
            <v-icon
                color="primary"
                size="120"
                class="material-icons-outlined mb-2"
            >
                email
            </v-icon>
            <h2 class="display-1">
                Check Your Email!
            </h2>
            <p class="body-1 font-weight-light">
                We have sent a verification email to your email address.<br>
                Please click the link inside to verify your account.
            </p>
            <p class="bidy-1 font-weight-light">
                This link will expire in 4 hours. If the link does expire, please log in and resend a new verification email.
            </p>
        </v-col>
        <v-col cols="12">
            <p class="caption grey--text text-center mb-1">
                Didn't receive an email at {{ userEmail }}?
            </p>
            <v-btn
                @click="sendVerificationEmail"
                color="primary"
                block
            >
                Resend Email
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import axios from 'axios'

import MessageBus from '../../utils/buses/MessageBus'
import { defaultError } from '../../utils/constants/errors'
import UserBus from '../../utils/buses/UserBus'

export default {
    data () {
        return {
            isSubmitting: false,
            userEmail: null
        }
    },
    // must be mounted so MessageBus can show a message on app load
    mounted () {
        this.userEmail = UserBus.user.email
    },
    methods: {
        sendVerificationEmail () {
            this.isSubmitting = true

            axios.post('/auth/verification-email')
                .then(res => {
                    MessageBus.sendMessage('Successfully sent verification email.', 'success')
                })
                .catch(err => {
                    console.error('Send Verification Email Error', err)
                    // user already verified
                    if (
                        err.status === 409
                        && err.data
                        && err.data.message
                        && err.data.message.includes('verified')
                    ) {
                        MessageBus.sendMessage('You are already verified.', 'success')
                        this.$router.push({ name: 'chooseHandle' })
                        return
                    }
                    MessageBus.sendMessage(defaultError, 'error')
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        }
    }
}
</script>
